<template>
  <main>
    <section-hero :bgImg="bgImg" :subtitle="subtitle"></section-hero>
    <section-article
      v-if="article.title"
      :article="article"
      isTopSection="true"
       id="scrollToOnLoad">
    </section-article>
    <section class="section--careers" v-if="scientists.length">
      <b-container>
        <b-row>
        <carousel-3d class="careers-slider"
        :perspective="0" :space="250" :display="showSlides" :width="360" :height="459"
        :scaling="200" :border="0" @after-slide-change="slideChanged" :controls-visible="true"
        :clickable="false">
          <slide class="careers-slide"
            v-for="(scientist, index) in scientists" :key="index" :index="index">
            <div class="scientist">
              <img class="img-fluid scientist__img" :src="domain + scientist.photo.url" alt="">
              <div>
                <h4 class="scientist__name">
                  {{ scientist.first_name }} {{ scientist.last_name }}
                </h4>
                <span class="scientist__status">{{ scientist.position }}</span>
                <p class="scientist__text">{{ scientist.school }}</p>
                <b-btn v-if="!isDesktop && !isOpen" @click="isOpen = !isOpen"
                  variant="primary" size="sm" class="scientist__button mb-sm-4 mb-0">
                  {{ $t("readMore") }}
                </b-btn>
              </div>
            </div>
          </slide>
        </carousel-3d>
        <b-col>
         <div class="slide__text" v-if="isDesktop || isOpen"
         v-html="scientists[activeSlideIndex].content">
        </div>
        </b-col>
        </b-row>
      </b-container>
    </section>
    <section-figures :figures="figures" itemColSize="3" isStatic="true"></section-figures>
    <section-support></section-support>
  </main>
</template>

<script>
import categories from '@/api/v1/categories';
import careers from '@/api/v1/careersInSciences';
import Hero from '@/components/Hero';
import Support from '@/components/Support/Index';
import Article from '@/components/Article';
import Figures from '@/components/Figures';

export default {
  data() {
    return {
      bgImg: 'Banner1-I_Love_Science-',
      subtitle: this.$t('nav.iLoveScience'),
      showSlides: 0,
      isOpen: false,
      scientists: [],
      domain: process.env.SERVER_URL,
      article: {},
      activeSlideIndex: 0,
      figures: [
        {
          imgName: 'school_photo_1.jpg',
          title: this.$t('careers.figure_title_1'),
          btnText: this.$t('check'),
          routeName: 'science_in_school',
        },
        {
          imgName: 'scientistgroup.jpg',
          title: this.$t('careers.figure_title_2'),
          btnText: this.$t('check'),
          routeName: 'ask_a_scientist',
        },
        {
          imgName: 'img-where_learn_more.jpg',
          title: this.$t('careers.figure_title_3'),
          btnText: this.$t('check'),
          routeName: 'learn_more',
        },
      ],
    };
  },
  components: {
    'section-hero': Hero,
    'section-support': Support,
    'section-article': Article,
    'section-figures': Figures,
  },
  computed: {
    isDesktop() {
      return (window.innerWidth > 1023);
    },
  },
  methods: {
    slideChanged(slideIndex) {
      this.activeSlideIndex = slideIndex;
    },
    slideToShow() {
      if (window.innerWidth > 767) {
        this.showSlides = 3;
      } else {
        this.showSlides = 1;
      }
    },
    getCategories() {
      const succ = (response) => {
        const article = response.data.categories[1].articles[0];
        this.figures.unshift({
          imgName: 'Outsidebuilding.jpg',
          title: article.title,
          header: '',
          btnText: 'Check',
          routeName: `/i_love_science/${article.id}`,
        });
      };
      categories.index(succ);
    },
    getCareerScience() {
      const succ = (response) => {
        this.article = response.data.careers_in_sciences;
        this.scientists = response.data.careers_in_sciences.scientists;
      };
      careers.index(succ);
    },
  },
  created() {
    this.getCareerScience();
    this.slideToShow();
    this.getCategories();
  },
};
</script>

<style lang="scss" scoped>
@import "./src/styles/helpers/_variables.scss";
@import "./src/styles/helpers/_include-media.scss";

.section--careers {
  background-color: #f1f1f1;
  padding: 100px 0;
  min-height: 900px;
  margin-bottom: 100px;
  @include media('<lg') {
    min-height: 500px;
    padding: 50px 0;
    margin-bottom: 50px;
  }
  @include media('<md') {
    padding: 0;
    background-color: $color--white;
  }
}
.scientist {
  padding: 40px 70px;
  background-color: $color--white;
  width: 360px;
  height: 460px;
  margin-bottom: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  @include media('<lg') {
    padding: 40px 50px 30px;
  }
  @include media('<md') {
    background-color: $color--gray-5;
    padding: 20px 30px 20px;
    width: 100%;
  }
  @include media('<sm') {
    height: 100%;
  }
  &__name {
    font-size: 20px;
    color: $color--gray-3;
    padding-top: 70px;
    @include media('<md') {
      padding-top: 40px;
    }
    @include media('<sm') {
      padding-top: 30px;
    }
  }
  &__status {
    display: block;
    font-size: 16px;
    margin-bottom: 35px;
    margin-top: 2px;
    color: $color--gray-3;
  }
  &__text {
    text-align: center;
    line-height: 22px;
  }
  &__button {
    position: relative;
    z-index: 2;
  }
  &__content {
    font-size: 16px;
    line-height: 18px;
    width: 100%;
  }
  img {
    @include media('<sm') {
      width: 130px;
    }
  }
}
.slide {
  &__text {
    padding-top: 20px;
    text-align: center;
    @include media('<md') {
      padding-bottom: 40px;
    }
  }
}
.careers-slide {
  &:before {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    background-color: $color--gray;
    width: 100%;
    height: 100%;
    opacity: 0.3;
    transition: opacity 0.5s ease;
  }
  &.current {
    &:before {
      opacity: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/StaticPages/Careers.vue